import React from 'react';
import { useNavbarContext } from '../Navbar';
import './NavLink.scss';
import classNames from "classnames";

export const NavLink = (props) => {
  const {
    item,
    onMouseOver,
    onMouseLeave,
    isSecondary,
    isWithStyle = false,
    isSelected = false,
    isDesktop = false,
    parentHasDropdown = false,
    level
  } = props;
  const { linkComponent, loginAction, logoutAction } = useNavbarContext();

  if (!linkComponent && item.type !== 'spa') {
    return (
      <LinkElement
        item={item}
        isSecondary={isSecondary}
        isWithStyle={isWithStyle}
        isSelected={isSelected}
        isDesktop={isDesktop}
        parentHasDropdown={parentHasDropdown}
        level={level}
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseLeave}
        loginAction={loginAction}
        logoutAction={logoutAction}
      />
    );
  }

  return linkComponent(
    <LinkElement
      item={item}
      isSecondary={isSecondary}
      isWithStyle={isWithStyle}
      isSelected={isSelected}
      isDesktop={isDesktop}
      parentHasDropdown={parentHasDropdown}
      level={level}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
      loginAction={loginAction}
      logoutAction={logoutAction}
    />,
    item
  );
};

const LinkElement = (props) => {
  const {
    item,
    onMouseOver,
    onMouseLeave,
    isSecondary,
    isWithStyle = false,
    isSelected = false,
    isDesktop = false,
    parentHasDropdown = false,
    level,
    loginAction,
    logoutAction,
  } = props;

  var itemClass;

  const switchClass = (level) => {
    switch (level) {
      case 0:
        itemClass = `${isSecondary ? 'primary-nav-link-top' : 'primary-nav-link'}`;
        break;
      case 1:
        itemClass = 'secondary-nav-link';
        break;
      case 2:
        itemClass = 'tertiary-nav-link';
        break;
      default:
        itemClass = '';
    }

    return itemClass;
  };

  return (
    parentHasDropdown ? (
      <>
        {item.link !== '#' ? (
          <a
            href = {item.link}
            title = {item.title}
            className = {classNames(
              switchClass(level),
              isSelected && 'selected',
              item.rel === "login" || item.rel === 'account' && 'profile',
            )}
            onTouchEnd = {isDesktop ? null : (isSelected ? onMouseLeave : onMouseOver)}
            onMouseOver = {isDesktop ? onMouseOver : null }
          >
            {item.rel === 'login' || item.rel === 'account' &&
              <svg className='icon' xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                <path fillRule="evenodd" clipRule="evenodd" d="M36 20C36 28.8366 28.8366 36 20 36C11.1634 36 4 28.8366 4 20C4 11.1634 11.1634 4 20 4C28.8366 4 36 11.1634 36 20ZM24 14C24 16.2091 22.2091 18 20 18C17.7909 18 16 16.2091 16 14C16 11.7909 17.7909 10 20 10C22.2091 10 24 11.7909 24 14ZM19.9999 22C15.9648 22 12.4879 24.3899 10.9075 27.8314C13.1081 30.3841 16.3653 32 20 32C23.6346 32 26.8917 30.3841 29.0923 27.8316C27.5119 24.39 24.035 22 19.9999 22Z" />
              </svg>
            }

            {item.title}

            {level === 0 ? (
              <div className='chevron'>
                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="4" viewBox="0 0 6 4" fill="none">
                  <path d="M2.4173 3.57721L0.254335 1.41425C-0.00910259 1.15081 -0.0678908 0.84938 0.0779707 0.50996C0.223832 0.170541 0.483665 0.000554606 0.85747 0L5.1418 0C5.51616 0 5.77627 0.169987 5.92213 0.50996C6.068 0.849934 6.00893 1.15136 5.74494 1.41425L3.58197 3.57721C3.49878 3.6604 3.40866 3.72279 3.3116 3.76439C3.21455 3.80599 3.11056 3.82678 2.99964 3.82678C2.88872 3.82678 2.78473 3.80599 2.68767 3.76439C2.59061 3.72279 2.50049 3.6604 2.4173 3.57721Z" fill="#EA4B4B"/>
                </svg>
              </div>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                <path d="M1 1.00004L5.66667 5.66671L1 10.3334" stroke="#141414" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            )}
          </a>
        ) : (
          <span
            title = {item.title}
            className = {classNames(
              switchClass(level),
              isSelected && 'selected',
              item.rel === "login" || item.rel === 'account' && 'profile',
              item.rel === "offer" && 'offer',
            )}
            onTouchEnd = {isDesktop ? null : (isSelected ? onMouseLeave : onMouseOver)}
            onMouseOver = {isDesktop ? onMouseOver : null }
          >
            {item.rel === 'login' || item.rel === 'account' &&
              <svg className='icon' xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                <path fillRule="evenodd" clipRule="evenodd" d="M36 20C36 28.8366 28.8366 36 20 36C11.1634 36 4 28.8366 4 20C4 11.1634 11.1634 4 20 4C28.8366 4 36 11.1634 36 20ZM24 14C24 16.2091 22.2091 18 20 18C17.7909 18 16 16.2091 16 14C16 11.7909 17.7909 10 20 10C22.2091 10 24 11.7909 24 14ZM19.9999 22C15.9648 22 12.4879 24.3899 10.9075 27.8314C13.1081 30.3841 16.3653 32 20 32C23.6346 32 26.8917 30.3841 29.0923 27.8316C27.5119 24.39 24.035 22 19.9999 22Z" />
              </svg>
            }
            
            {item.title}

            {level === 0 ? (
              <div className='chevron'>
                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="4" viewBox="0 0 6 4" fill="none">
                  <path d="M2.4173 3.57721L0.254335 1.41425C-0.00910259 1.15081 -0.0678908 0.84938 0.0779707 0.50996C0.223832 0.170541 0.483665 0.000554606 0.85747 0L5.1418 0C5.51616 0 5.77627 0.169987 5.92213 0.50996C6.068 0.849934 6.00893 1.15136 5.74494 1.41425L3.58197 3.57721C3.49878 3.6604 3.40866 3.72279 3.3116 3.76439C3.21455 3.80599 3.11056 3.82678 2.99964 3.82678C2.88872 3.82678 2.78473 3.80599 2.68767 3.76439C2.59061 3.72279 2.50049 3.6604 2.4173 3.57721Z" fill="#EA4B4B"/>
                </svg>
              </div>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                <path d="M1 1.00004L5.66667 5.66671L1 10.3334" stroke="#141414" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            )}
          </span>
        )}
      </>
      
    ) : (
      <a
        href = {item.link}
        title = {item.title}
        className = {classNames(
          switchClass(level),
          isSelected && 'selected',
          item.rel === "login" && 'topButton login',
          item.rel === "callcenter" && 'topButton callcenter',
        )}
        onClick = {(e) => {
          if (item.type === 'prevent' || item.type === 'spa') {
            e.preventDefault();
          }

          if(item.rel === 'login') {
            loginAction()
          }

          if(item.rel === 'account') {
            logoutAction()
          }

          item.onClick && item.onClick(item);
        }}
      >
        {item.rel === 'callcenter' &&
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M1.3385 3.33332C1.3385 2.23069 2.23219 1.33789 3.33331 1.33789H5.51947C6.09075 1.33789 6.59847 1.70347 6.7794 2.24628L7.77795 5.24191C7.9872 5.86967 7.70284 6.55532 7.11176 6.85086L6.20309 7.3052C6.7956 8.34172 7.65842 9.2044 8.69522 9.79678L9.14987 8.88749C9.44564 8.29595 10.1309 8.01245 10.7575 8.22132L13.7531 9.21986C14.2953 9.40056 14.6615 9.90816 14.6615 10.4805V12.6666C14.6615 13.7693 13.7678 14.6621 12.6666 14.6621H12C6.11239 14.6621 1.3385 9.88907 1.3385 3.99998V3.33332ZM3.33331 2.66208C2.96168 2.66208 2.66146 2.96318 2.66146 3.33332V3.99998C2.66146 9.15659 6.84188 13.3379 12 13.3379H12.6666C13.0383 13.3379 13.3385 13.0368 13.3385 12.6666V10.4805C13.3385 10.4789 13.3375 10.477 13.3351 10.4762L10.3395 9.47767C10.3382 9.47723 10.3377 9.47726 10.3376 9.47727L10.3376 9.47727C10.3374 9.47728 10.3371 9.47731 10.3368 9.4774C10.3364 9.47748 10.336 9.4776 10.3355 9.4778C10.335 9.47801 10.3346 9.47823 10.3343 9.47842C10.334 9.4786 10.3338 9.47875 10.3337 9.47884L10.3336 9.47904L10.3329 9.48012L9.58052 10.985C9.42171 11.3026 9.04083 11.4382 8.71731 11.2923C6.94051 10.4912 5.50962 9.06042 4.70839 7.28333C4.56228 6.95927 4.69796 6.57756 5.01571 6.41868L6.52056 5.66626L6.52177 5.66555L6.52199 5.66535C6.52215 5.66517 6.52254 5.66467 6.52289 5.66383C6.52324 5.66298 6.5233 5.6624 6.52331 5.66226L6.5233 5.66214L6.523 5.661L5.52445 2.66538L6.13366 2.46193L5.52445 2.66538C5.5239 2.66373 5.5221 2.66208 5.51947 2.66208H3.33331Z"/>
          </svg>
        }

        {item.rel === 'login' &&
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M2.41402 10.8692C3.76844 10.1036 5.3332 9.66667 7 9.66667C8.66681 9.66667 10.2316 10.1036 11.586 10.8692M9 5.66667C9 6.77124 8.10457 7.66667 7 7.66667C5.89543 7.66667 5 6.77124 5 5.66667C5 4.5621 5.89543 3.66667 7 3.66667C8.10457 3.66667 9 4.5621 9 5.66667ZM13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        }
      
        {item.title}
      </a>
    )
  );
};
